// Source/Download-Link/Download.ts
var { userAgent } = window.navigator;
var isIOS = userAgent.match(/Macintosh/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPad/i);
var isWebkit = userAgent.match(/WebKit/i);
var isIOSSafari = !!(isIOS && isWebkit && !userAgent.match(/CriOS/i) && !userAgent.match(/EdgiOS/i) && !userAgent.match(/Chrome/i) && !userAgent.match(/Edg/i));
async function download(href) {
  const isPDF = href.includes(`.pdf?`);
  const response = await fetch(href);
  const blob = isPDF && isIOSSafari ? new Blob([await response.arrayBuffer()], {
    type: "application/octet-stream"
  }) : await response.blob();
  const url = URL.createObjectURL(blob);
  const file = new URL(href).pathname.split("/").pop();
  const link = document.createElement("a");
  link.href = url;
  link.download = file;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

// Source/Download-Link/Component.ts
var Selector_Downloads = `a[ data-download = true ]`;

class DetectDownloadable extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(Selector_Downloads).forEach((link) => {
      link.addEventListener("click", async (event) => {
        event.preventDefault();
        DetectDownloadable.downloading = true;
        console.debug(`Starting download`, link.href);
        document.documentElement.dataset.isDownloading = String(true);
        await download(link.href).catch(console.error.bind(console));
        console.debug(`Finished download`);
        DetectDownloadable.downloading = false;
      });
    });
  }
  static set downloading(state) {
    document.documentElement.dataset.isDownloading = String(state);
  }
}

// Source/Download-Link/mod.ts
customElements.define("detect-downloadable", DetectDownloadable);
